import auth0 from 'auth0-js'
import { AUTH_CONFIG } from './auth0-variables'
import history from '../history'

export default class Auth {
  tokenRenewalTimeout

  auth0 = new auth0.WebAuth({
    domain: AUTH_CONFIG.domain,
    clientID: AUTH_CONFIG.clientID,
    redirectUri: AUTH_CONFIG.redirectUri,
    audience: AUTH_CONFIG.audience,
    responseType: 'token id_token',
    scope: 'openid'
  })

  constructor () {
    this.scheduleRenewal()
  }

  login = () => this.auth0.authorize()

  handleAuthentication = () => {
    this.auth0.parseHash((err, authResult) => {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.setSession(authResult)
        history.replace('/')
      } else if (err) {
        history.replace('/')
        console.log(err)
      }
    })
  }

  setSession = authResult => {
    // Set the time that the access token will expire at
    let expiresAt = JSON.stringify(
      authResult.expiresIn * 1000 + new Date().getTime()
    )

    localStorage.setItem('access_token', authResult.accessToken)
    localStorage.setItem('id_token', authResult.idToken)
    localStorage.setItem('expires_at', expiresAt)

    // schedule a token renewal
    this.scheduleRenewal()
  }

  getAccessToken = () => {
    const accessToken = localStorage.getItem('access_token')
    if (!accessToken) {
      throw new Error('No access token found')
    }
    return accessToken
  }

  logout = () => {
    // Clear access token and ID token from local storage
    localStorage.removeItem('access_token')
    localStorage.removeItem('id_token')
    localStorage.removeItem('expires_at')
    localStorage.removeItem('scopes')
    this.userProfile = null
    clearTimeout(this.tokenRenewalTimeout)
    // navigate to the home route
    this.auth0.logout({ returnTo: AUTH_CONFIG.logoutUrl })
  }

  isAuthenticated = () => {
    // Check whether the current time is past the
    // access token's expiry time
    let expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    return new Date().getTime() < expiresAt
  }

  renewToken = () => {
    this.auth0.checkSession({}, (err, result) => {
      if (err) {
        console.log(
          `Could not get a new token (${err.error}: ${err.error_description}).`
        )
      } else {
        this.setSession(result)
      }
    })
  }

  scheduleRenewal = () => {
    const expiresAt = JSON.parse(localStorage.getItem('expires_at'))
    const delay = expiresAt - Date.now()
    if (delay > 0) {
      this.tokenRenewalTimeout = setTimeout(() => {
        this.renewToken()
      }, delay)
    }
  }
}



// WEBPACK FOOTER //
// ./src/auth/auth.js